import { render, staticRenderFns } from "./AddQueueItemDialog.vue?vue&type=template&id=5b48897c"
import script from "./AddQueueItemDialog.vue?vue&type=script&lang=js"
export * from "./AddQueueItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports